//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Button, Grid, Typography } from '@mui/material'
import React, { ReactElement } from 'react'

import { EthAddr } from '@shared/SchemaTypes'

import { theme } from '@react/components/theme'

import { Erc20Wei, erc20WeiToCommaDecString } from '@shared/conversions'
import { AddressPill } from '@react/components/addresses/AddressPill'

import { IPoolLenderWithdrawEventStructOutput } from '@typechain-types/contracts/PoolFlex'
import { useOtDispatch } from '@react/redux/store'
import { logOT } from '@shared/loggingShared'
import { borrowerTransferRepayFlexWithdrawalTx } from '@react/signedTxs/borrowerTransferRepayFlexWithdrawalTx'

export default function BorrowerTransferForRepayFlexForm(props: {
  poolAddr: EthAddr
  withdrawEvent: IPoolLenderWithdrawEventStructOutput
}): ReactElement {
  const { poolAddr, withdrawEvent } = props

  const dispatch = useOtDispatch()

  const [isSubmitted, setIsSubmitted] = React.useState(false)

  const sx = {
    backgroundColor: theme.palette.fg.main,
    color: '#FFFFFF',
    padding: '11px 16px 11px 16px',
    marginLeft: '8px',
    borderRadius: '6px',
    marginTop: 2,
  }

  const borrowerTransferRepayFlexWithdrawalAction = (): void => {
    setIsSubmitted(true)

    dispatch(
      borrowerTransferRepayFlexWithdrawalTx({
        poolAddr,
        eventId: withdrawEvent.eventId.toString() ?? '',
        requestedAssets: Erc20Wei(withdrawEvent.requestedAssets ?? 0),
      })
    )
    const event = new Event('modalClose')
    window.dispatchEvent(event)
  }
  const disableButton = false
  // const disableButton = weiToNumber(poolCTO?.borrowerVaultBalance) < Number(withdrawEvent.requestedAssets.toNumber())

  logOT.info('withdrawEvent', withdrawEvent)
  return (
    <div data-testid="REPAY_EARLY_REDEEM_FORM">
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Typography variant="body" align="left" sx={{ marginBottom: 2 }}>
            Please confirm you want to execute the Loan Repayment. Once confirmed, the Liquidity Asset will be sent from
            the Borrower Vault to the Lender’s Wallet.
          </Typography>
        </Grid>
      </Grid>

      <Grid container sx={{ marginTop: 2 }}>
        <Grid container item xs={12}>
          <Grid item xs={3}>
            Lender
          </Grid>
          <Grid item xs={5}>
            Request Amount
          </Grid>
          <Grid item xs={4}>
            Principal
          </Grid>
        </Grid>

        <Grid container item xs={12}>
          <Grid item xs={3}>
            <AddressPill addr={withdrawEvent.lender} />
          </Grid>
          <Grid item xs={5}>
            {erc20WeiToCommaDecString(withdrawEvent.requestedAssets ?? 0)}
          </Grid>
          <Grid item xs={4}>
            Dont know original Principal
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Button
            disabled={isSubmitted || disableButton || Number(withdrawEvent.requestedAssets ?? 0) <= 10}
            sx={sx}
            onClick={() => {
              borrowerTransferRepayFlexWithdrawalAction()
            }}
            variant={'contained'}
          >
            <Typography variant={'buttonBold'}>Confirm Loan Repayment</Typography>
          </Button>
        </Grid>
        {/* {disableButton && (
          <Typography variant="body" align="left" sx={{ marginBottom: 2 }}>
            The amount you are trying to send for withdraw is greater than the amount of USDC available in your vault (
            {weiToNumber(poolCTO?.borrowerVaultBalance)}). Please deposit funds to the borrowerVault
          </Typography>
        )} */}
      </Grid>
    </div>
  )
}
